import styled from 'styled-components';

export const ClickOverlay = styled.div<{ isActive: boolean }>`
  display: ${props => (props.isActive ? 'block' : 'none')} !important;
  position: fixed;
  z-index: ${props => props.theme.zIndices.overlay};
  background-color: transparent;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
`;

export const ShadowOverlay = styled.div<{ isActive: boolean }>`
  display: ${props => (props.isActive ? 'block' : 'none')} !important;
  position: absolute;
  z-index: 1000;
  transition: all 0.5s ease;

  width: 100%;
  height: 100%;
  left: 0;
  top: 0;

  /* TODO: Pass in as props something like circle or fill shape instead of basing it off screen size for
  future use */
  ${props => props.theme.mediaQueries.smallDown} {
    border-radius: 100%;
    width: ${props => props.theme.space['8.0']};
    height: ${props => props.theme.space['8.0']};
    left: unset;
    top: unset;
  }

  box-shadow: 0 0 0 200rem rgba(27, 52, 88, 0.5);
`;

export const NewArchivedPageBaseModal = styled.div<{
  isActive: boolean;
  handleModalClose: () => void;
  showExitIcon: boolean;
}>`
  width: ${props => props.theme.space['32']};
  height: auto;
  position: absolute;

  display: ${props => (props.isActive ? 'block' : 'none')} !important;

  /* Desktop orientation */
  top: -${props => props.theme.space['0.5']};
  left: 100%;
  padding-left: ${props => props.theme.space['4.0']};

  /* iPhone X like devices */
  ${props => props.theme.mediaQueries.smallDown} {
    top: unset;
    bottom: ${props => props.theme.space['62']};
    left: unset;
    right: -${props => props.theme.space['3.5']};
    padding-left: 0;
  }

  /* iPhone SE like devices */
  ${props => props.theme.mediaQueries.smallWidthAndHeightDown} {
    top: unset;
    bottom: ${props => props.theme.space['40']};
    right: -${props => props.theme.space.s7};
    left: unset;
  }
`;

export const NewArchivedMedicationPageContainer = styled.div`
  position: absolute;
  z-index: 1001;
  background-color: white;
  width: 28rem;
  padding: ${props => props.theme.space['2.0']};
  border-radius: ${props => props.theme.space['0.3']};
  cursor: default;
`;
